import { render, staticRenderFns } from "./HowToSection.vue?vue&type=template&id=70d498aa&scoped=true"
import script from "./HowToSection.vue?vue&type=script&lang=js"
export * from "./HowToSection.vue?vue&type=script&lang=js"
import style0 from "./HowToSection.vue?vue&type=style&index=0&id=70d498aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d498aa",
  null
  
)

export default component.exports